<template lang="pug">
.contenedor(:class="getContainerClass()")
  .asu-title(v-if="institucion === 'MOPC'") Proyectos del Ministerio de Obras Públicas y Comunicaciones
  .asu-title(v-if="institucion === 'MAC'") Proyectos de la Municipalidad de Asunción
  .asu-title(v-if="institucion === 'MUVH'") Proyectos del Ministerio de Urbanismo, Vivienda y Hábitat
  div(v-else)
  .participe
    .asu-logo
      img(src="@/assets/img/asuparticipa.png")
    a(@click="openApp('Comentario')")
      img(src="@/assets/img/icons/participe.svg" class="participe-icon")
      span Participa
    .asu-subtitle Consulta, Sugerencia, Reclamo
    .icons
      md-button.material-icons-button(@click="openApp('Pedido de Documento')")
        i.ap-Pedido-documento
        md-tooltip(md-direction="top") Solicitar Documento
      md-button.material-icons-button(@click="openApp('Comentario')")
        i.ap-Comentario
        md-tooltip(md-direction="top") Comentario
      md-button.material-icons-button(@click="openApp('Reclamo')")
        i.ap-reclamo
        md-tooltip(md-direction="top") Reclamo
      md-button.material-icons-button(@click="openApp('Otro')")
        i.material-icons.otro add
        md-tooltip(md-direction="top") Otro
</template>
<script>
export default {
  mounted () {
    this.institucion = this.$route.query.institucion
  },
  methods: {
    openApp (text) {
      window.open(`${process.env.VUE_APP_BASE_URL}enviar-mensaje/${text}`)
    },
    getContainerClass () {
      return this.institucion.toLowerCase()
    }
  },
  data () {
    return {
      institucion: ''
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/styles/variables'

$icon-size = 30px

.contenedor {
  border: 3px solid rgb(13, 37, 99)
  margin: auto
  color: rgb(13, 37, 99)
  box-sizing: border-box
  text-decoration: none
  text-align: center
  font-size: 1.2rem
  font-weight: 700
  vertical-align: middle
  padding: 10px
  width: 275px
  &.mopc,
  &.muvh {
    width: 382px
  }
}

.participe {
  margin: 0 auto
  width: 227px
}

.icons {
  display: flex
  justify-content: space-between
  padding-top: 7px
}

.material-icons-button {
  background-color: $color_0
  border-radius: 50%
  height: $icon-size
  min-width: $icon-size
  width: $icon-size
  i {
    color: white
    font-size: 19px
    &.ap-twitter {
      font-size: 16px
    }
  }
  &[disabled] i {
    color: #ccc
  }
  &.mensaje,
  &.telefono {
    min-width: $icon-size
    width: $icon-size + 1px
    background-color: #fff
    i {
      color: $color_0
      font-size: $icon-size
    }
    &[disabled] i{
      color: $gray_color
    }
  }
  i.material-icons.otro {
    color: #fff
    font-weight: bold
  }
}

.asu-title {
  font-size: 14px
  margin-bottom: 8px
}

.asu-subtitle {
  font-size: 11px
}

.material-icons-button:first-child {
  margin-left: 0
}

.material-icons-button:last-child {
  margin-right: 0
}

.material-icons-button i.ap-reclamo {
  font-size: $f13px
}

.asu-logo {
    float: left
    width: 80px
    margin-right: 5px
}
</style>
